var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrolley = function SvgTrolley(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "trolley_svg__svg-icon"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#trolley_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.368 15.579v-8.21H5V6h2.737v8.21H18v1.369H6.368ZM7.737 19c-.376 0-.699-.134-.967-.402a1.318 1.318 0 0 1-.402-.966c0-.377.134-.699.402-.967s.59-.402.967-.402c.376 0 .698.134.966.402s.402.59.402.967c0 .376-.134.698-.402.966s-.59.402-.966.402Zm.684-5.474V9.421h4.105v4.105H8.421Zm4.79 0V9.421h4.105v4.105H13.21Zm2.454 5.072a1.318 1.318 0 0 1-.402-.966c0-.377.134-.699.402-.967s.59-.402.967-.402c.376 0 .698.134.966.402s.402.59.402.967c0 .376-.134.698-.402.966s-.59.402-.966.402c-.377 0-.699-.134-.967-.402Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "trolley_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
};
export { SvgTrolley as ReactComponent };